let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hB5OJ")).then(() => parcelRequire('3VgLl'));